var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {
      staticClass:
        "mdi mdi-close fs_xl color_green close-modal close-modal--video cursor-pointer",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.toggleHandler($event)
        }
      }
    }),
    _c("iframe", {
      staticClass: "video-modal",
      attrs: {
        src: _vm.src,
        frameborder: "0",
        allow:
          "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: "allowfullscreen",
        height: "100%"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c88a0f00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c88a0f00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Modal/VideoModal.vue
// module id = 39
// module chunks = 0